var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormatTintSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-3h24v24H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.793 16.559L1.238.123a.542.542 0 00-.773.088L.12.65a.57.57 0 00.085.79l20.557 16.437a.542.542 0 00.773-.088l.343-.439a.571.571 0 00-.086-.791zM11 2.94c.796 1.998 1.788 3.449 2.62 4.664.144.21.28.411.41.605l2.896 2.315c-.616-3.083-3.484-4.79-4.921-9.748A1.026 1.026 0 0010.999 0c-.424 0-.85.253-1.003.777A16.35 16.35 0 018.702 3.95l1.31 1.048c.345-.624.682-1.29.988-2.057zm0 13.372c-2.426 0-4.4-2.052-4.4-4.574 0-.926.266-1.675.714-2.474L6.005 8.22c-.623 1.063-1.055 2.142-1.055 3.52C4.95 15.199 7.656 18 11 18c1.82 0 3.445-.833 4.554-2.146l-1.312-1.049c-.805.92-1.954 1.508-3.242 1.508z",
    fill: "#151A30"
  }))));
}

export default SvgFormatTintSlash;